import React from 'react';

/**
 * React context for the ExpansionPanel family
 */
export default React.createContext({ disabled: false });